var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"reklamark"},[_c('br'),_c('br'),_c('img',{attrs:{"id":"tips1","src":require("../../assets/tips1.jpg"),"alt":"tips1"}})])])
}]

export { render, staticRenderFns }